import React from 'react';

import classNames from 'classnames';

// IB-677 rework — shared card chrome for the RADIO dashboards. Matches the wireframe
// widget card (white, rounded, compact padding) using the Procurement panel shadow
// token (`shadow-primary`) so density/card-sizing is indistinguishable from the
// shipped Procurement dashboards.

// Small pill flag shown next to a card title (wireframe .flag).
// PR review (#1060): 'edge'/'same' tones were never invoked anywhere in the RADIO
// dashboards (and 'same' carried a stray #00805a hex outside the palette) — trimmed
// to the tone actually used. Add a tone back only alongside a real call site.
export function Flag({ tone = 'new', children }) {
    const cls = {
        new: 'tw-bg-blue-25 tw-text-blue',
    }[tone];

    return <span className={classNames('tw-text-2xs tw-font-medium tw-rounded-full tw-px-2 tw-py-0.5 tw-whitespace-nowrap', cls)}>{children}</span>;
}

export function CardHeader({ title, flag }) {
    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-3">
            <span className="tw-text-sm tw-font-semibold tw-text-charcoal">{title}</span>
            {flag}
        </div>
    );
}

export default function Card({ title, flag, minHeight, className, children }) {
    return (
        <div className={classNames('tw-rounded-lg tw-bg-white tw-shadow-primary tw-p-4', className)} style={minHeight ? { minHeight } : undefined}>
            {title != null && <CardHeader title={title} flag={flag} />}
            {children}
        </div>
    );
}
